/**
 * MinistrareIA - Support Tickets Service
 * API service for support tickets management (JWT-authenticated).
 */
import api from '../global/api';

const BASE = '/api/support/tickets';

class TicketService {
  /** List tickets with optional filters */
  async list(filters = {}) {
    const params = {};
    if (filters.status && filters.status !== 'all') params.status = filters.status;
    if (filters.phone) params.phone = filters.phone;
    if (filters.limit) params.limit = filters.limit;
    if (filters.offset) params.offset = filters.offset;
    const response = await api.get(BASE, { params });
    return response.data;
  }

  /** Get ticket counts grouped by status */
  async getCounts() {
    const response = await api.get(`${BASE}/counts`);
    return response.data;
  }

  /** Get a single ticket by ID */
  async getById(id) {
    const response = await api.get(`${BASE}/${id}`);
    return response.data;
  }

  /** Números admin que recebem avisos por WhatsApp */
  async getNotifyConfig() {
    const response = await api.get(`${BASE}/notify-config`);
    return response.data;
  }

  /** phones: ["5521999990000"] ou [{ phone, kinds: ["ticket"] }] */
  async setNotifyConfig(phones) {
    const response = await api.put(`${BASE}/notify-config`, { phones });
    return response.data;
  }

  async sendNotifyTest() {
    const response = await api.post(`${BASE}/notify-test`);
    return response.data;
  }

  /** Update ticket status (and optionally agent_notes) */
  async updateStatus(id, status, agentNotes = null) {
    const body = { status };
    if (agentNotes !== null) body.agent_notes = agentNotes;
    const response = await api.put(`${BASE}/${id}/status`, body);
    return response.data;
  }
}

const ticketService = new TicketService();
export default ticketService;
